import { stringify } from 'qs';
import request from '../utils/request';

const MODEL = '/admin/app';

export async function list(params) {
  return request(`${MODEL}?${stringify(params)}`);
}

export async function get(id, params) {
  return request(`${MODEL}/${id}?${stringify(params)}`);
}

export async function create(params) {
  return request(`${MODEL}`, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function update(id, params) {
  return request(`${MODEL}/${id}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}

export async function remove(ids) {
  return request(`${MODEL}/${ids}`, {
    method: 'delete',
  });
}

export async function listRechargeLog(params) {
  return request(`${MODEL}/recharge-log?${stringify(params)}`);
}

export async function createRechargeLog(params) {
  return request(`${MODEL}/recharge`, {
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(params),
  });
}
